module.exports = __webpack_public_path__ + "static/media/color-circle.fb8bbc26.png";